export const SUBDOMAIN_REGEX = '^[^\\-][A-Za-z0-9\\-]*[^\\-]';

/**
 * Basic email regex, guards against two dots together, dot at beginning or end of local part or domain
 */
export const EMAIL_REGEX =
  '^[\\w%+\\-]+(\\.[\\w%+\\-]+)*@[A-Za-z0-9\\-]+(\\.[A-Za-z0-9\\-]+)*\\.[A-Za-z]{2,}$';

export const FTP_HOST_REGEX =
  '^(([A-Za-z0-9]([A-Za-z0-9\\-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z]{2,}|((25[0-5]|2[0-4]\\d|[01]?\\d\\d?)\\.){3}(25[0-5]|2[0-4]\\d|[01]?\\d\\d?))(:\\d{1,5})?$';
